import { render } from "./ContentWrapper.vue?vue&type=template&id=555567ce&scoped=true"
import script from "./ContentWrapper.vue?vue&type=script&lang=js"
export * from "./ContentWrapper.vue?vue&type=script&lang=js"

import "./ContentWrapper.vue?vue&type=style&index=0&id=555567ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555567ce"]])

export default __exports__